import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopRight32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRadiusTopRight32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25.012 20.792v-4.821a9 9 0 0 0-9-9H11.09a1 1 0 1 1 0-2h4.922c6.075 0 11 4.925 11 11v4.821a1 1 0 1 1-2 0M17.25 25.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m3.762 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.5 10.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M6.25 22.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.5 16A1.25 1.25 0 1 1 5 16a1.25 1.25 0 0 1 2.5 0m3.789 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopRight32);
